import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';

import * as evaluacionesActions from '../actions'
import {catchError, map, switchMap} from 'rxjs/operators';
import {EvaluacionService} from '../../docente/evaluacion/evaluacion.service';
import {Evaluacion} from '../../docente/evaluacion';
import {of} from 'rxjs';
@Injectable()
export class EvaluacionesEffects {
  constructor(private actions$: Actions,
              private evaluacionService: EvaluacionService) {}

  @Effect()
  cargarEvaluacionesGrupo$ = this.actions$
    .pipe(
      ofType(evaluacionesActions.CARGAR_EVALUACIONES_GRUPO),
      switchMap( (action: any) => {
        return this.evaluacionService.evaluacionesGrupo(action.grupoId)
          .pipe(
            map( (evaluaciones: Evaluacion[]) => {
              return new evaluacionesActions.CargarEvaluacionesGrupoSuccess(evaluaciones);
            }),
            catchError( error => of(new evaluacionesActions.CargarEvaluacionesGrupoFail(error)))
          )
      })
    );

  @Effect()
  cargarEvaluaciones$ = this.actions$
    .pipe(
      ofType(evaluacionesActions.CARGAR_EVALUACIONES),
      switchMap( () => {
        return this.evaluacionService.index()
          .pipe(
            map( (evaluaciones: Evaluacion[]) => {
              return new evaluacionesActions.CargarEvaluacionesSuccess(evaluaciones);
            }),
            catchError( error => of(new evaluacionesActions.CargarEvaluacionesFail(error)))
          )
      })
    );

  @Effect()
  guardarEvaluacion$ = this.actions$
    .pipe(
      ofType(evaluacionesActions.GUARDAR_EVALUACION),
      switchMap((action: any) => {
        return this.evaluacionService.store(action.evaluacion)
          .pipe(
            map( (evaluacion: Evaluacion) => {
              return new evaluacionesActions.GuardarEvaluacionSuccess(evaluacion);
            }),
            catchError( error => of(new evaluacionesActions.GuardarEvaluacionFail(error)))
          )
      })
    );

  @Effect()
  actualizarEvaluacion$ = this.actions$
    .pipe(
      ofType(evaluacionesActions.ACTUALIZAR_EVALUACION),
      switchMap((action: any) => {
        return this.evaluacionService.update(action.evaluacion, action.evaluacionId)
          .pipe(
            map((evaluacion: Evaluacion) => new evaluacionesActions.ActualizarEvaluacionSuccess(evaluacion, evaluacion.evaluacion_id)),
            catchError( error => of(new evaluacionesActions.ActualizarEvaluacionFail(error)))
          )
      })
    );
  @Effect()
  eliminarEvaluacion$ = this.actions$
    .pipe(
      ofType(evaluacionesActions.ELIMINAR_EVALUACION),
      switchMap((action: any) => {
        return this.evaluacionService.destroy(action.evaluacionId)
          .pipe(
            map(() => new evaluacionesActions.EliminarEvaluacionSuccess(action.evaluacionId)),
            catchError( error => of(new evaluacionesActions.EliminarEvaluacionFail(error)))
          )
      })
    );
}
